import axios, { AxiosRequestConfig } from 'axios';
import { authHeader } from '../../shared/helpers/authHeader';
import { routeConstants } from '../../shared/routes/route.constants';
import { remoteConfigEndpoints } from './remote.config.endpoints';
import { IRemoteConfig } from './remote.config.interfaces';

axios.interceptors.request.use(function (config) {
    config.headers.Authorization = localStorage.getItem('token');
    return config;
});

export const getRemoteConfig = async (): Promise<IRemoteConfig> => {
    try {
        const requestOptions: AxiosRequestConfig = {
            url: remoteConfigEndpoints.GET_REMOTE_CONFIG.url,
            method: routeConstants.METHODS.GET,
            headers: authHeader(),
        };

        const response = await axios(requestOptions);

        if (!response.data || !response.data.data) {
            throw new Error('Invalid response format from server');
        }

        return response.data.data;
    } catch (error) {
        if (axios.isAxiosError(error)) {
            throw new Error(error.response?.data?.message || 'Failed to fetch remote config');
        }
        throw error;
    }
};

export const updateRemoteConfig = async (config: IRemoteConfig): Promise<IRemoteConfig> => {
    try {
        const requestOptions: AxiosRequestConfig = {
            url: remoteConfigEndpoints.UPDATE_REMOTE_CONFIG.url,
            method: routeConstants.METHODS.PUT,
            headers: authHeader(),
            data: config,
        };

        const response = await axios(requestOptions);

        if (!response.data || !response.data.data) {
            throw new Error('Invalid response format from server');
        }

        return response.data.data;
    } catch (error) {
        if (axios.isAxiosError(error)) {
            throw new Error(error.response?.data?.message || 'Failed to update remote config');
        }
        throw error;
    }
};
